<script>
  import { onMount, onDestroy } from "svelte";
  import anime from "animejs";

  export let id;
  export let path =
    "M132.11 2.00 C 132.11 2.00, 321.00 179.00, 250.00 240.00 C 179.00 301.00, 74.00 244.00, 15.00 306.00 C -44.00 368.00, 132.00 540.00, 132.00 540.00";
  let self;
  let observer;
  let pathArr = path.replace(/[^\d\W]/gi, "").split(" ");
  const [startStrX, startStrY, ...pathRemArr] = pathArr;
  const [endStrY, endStrX] = pathRemArr.reverse();

  const startX = parseFloat(startStrX, 10);
  const startY = parseFloat(startStrY, 10);
  const endX = parseFloat(endStrX, 10);
  const endY = parseFloat(endStrY, 10);

  function drawLine(elStr = id, delay = 0, duration = 1000) {
    anime({
      targets: `#${elStr} svg path`,
      strokeDashoffset: [anime.setDashoffset, 0],
      duration,
      delay,
      easing: "easeInOutCirc",
      begin: () => {
        anime({
          targets: `#${elStr} svg line:first-of-type`,
          strokeWidth: [0, 6],
          duration: 250,
          delay,
          easing: "linear"
        });
        anime({
          targets: `#${elStr} svg line:last-of-type`,
          strokeWidth: [0, 6],
          duration: 250,
          delay: delay + 700,
          easing: "linear"
        });
      }
    });
  }

  onMount(() => {
    anime({
      targets: `.static-line svg path`,
      strokeDashoffset: anime.setDashoffset,
      duration: 0
    });
    anime({
      targets: `.static-line svg line:first-of-type`,
      strokeWidth: 0,
      duration: 0
    });
    anime({
      targets: `.static-line svg line:last-of-type`,
      strokeWidth: 0,
      duration: 0
    });

    let observer = new IntersectionObserver(
      function(entries, observer) {
        if (entries[0].isIntersecting) {
          drawLine();
          observer.unobserve(self);
        }
      },
      {
        threshold: 0.2,
        rootMargin: "0px 0px 0px 0px"
      }
    );
    observer.observe(self);
  });

  onDestroy(() => {
    observer.unobserve(self);
  });
</script>

<style lang="scss">
  $colorSecondary: #fbab61;
  $colorTertiary: #e0654f;

  div {
    // outline: 1px dotted white;
    font-size: 0px;
    z-index: 1;
    transform: translateY(-3px);

    svg {
      width: 100%;
      height: 100%;
      overflow: visible;

      path {
        fill: none;
        stroke: #aac4e5;
        stroke-width: 2;
        stroke-linecap: butt;
        stroke-linejoin: miter;
        stroke-miterlimit: 4;
      }

      line {
        stroke-linecap: round;
        stroke-width: 6;
        vector-effect: non-scaling-stroke;
        stroke: $colorSecondary;

        &:nth-of-type(2) {
          stroke: $colorTertiary;
        }
      }
    }
  }
</style>

<div {id} class="static-line" bind:this={self} style="width: {endX - startX}px; height: {endY - startY}px">
  <svg>
    <path d={path} />
    <line x1={`${startX}`} x2={`${startX}`} y1={`${startY}`} y2={`${startY}`} />
    <line x1={`${endX}`} x2={`${endX}`} y1={`${endY}`} y2={`${endY}`} />
  </svg>
</div>
